import {useEffect, useRef, useState} from "react"
import Cart from "../models/Cart"
import {getCart} from "../Modules/Cart/Request"
import * as Sentry from "@sentry/react"

interface Props {
  embebed: boolean
  publicToken: string
}

export const useCart = (props: Props) => {
  
  const initialDevelop = {
    name: '',
    surname: '',
    telephone: '',
    email: '',
    pickUpLocations: '',
    dropOffLocations: '',
    flightInfo: '',
    additionalInformation: ''
  }
  
  const [cart, setCart] = useState<Cart>()
  const [dataBooking, setDataBooking] = useState<{ [name: string]: string }>(initialDevelop)
  const [clientName, setClientName] = useState(null)
  
  const [cartError, setCartError] = useState(null)
  const [loading, setLoading] = useState<boolean>(false)
  
  const {embebed, publicToken} = props
  useEffect(() => {
    try {
      const tokenTicket = localStorage.getItem('tokenTicket')
      setLoading(true)
      getCart(tokenTicket, embebed ? 'opDXLdbBtYTCOdvtOamctbkBsHcssCehriFELgFFFYHTCCNRcAsXbdYUkBMdDrLuZQxkwD' : publicToken)
        .then((res) => {
          if (res.code && res.code === 433) { // 433: carrito ya cobrado
            try {
              localStorage.removeItem('tokenTicket')
            } catch (e) {
              console.log(e)
            }
          }
          if (res.statusCode === 401) {
            Sentry.captureException(new Error("CartPage - Cliente no encontrado"))
            return null
          } else if (res.statusCode === 404) {
            Sentry.captureException(new Error("CartPage - Cart"))
            return null
          }
          if (!res.error) {
            setCart(res)
            if (res.contact) {
              const temp = res.contact
              console.log('datos contacto: ', temp)
              setDataBooking(temp)
            }
            setClientName(res.clientName)
            localStorage.setItem('clientName', res.clientName)
          }
          setLoading(false)
        })
        .catch(reason => {
          console.log('error: ', reason)
          setCartError(reason)
          setLoading(false)
        })
    } catch (e) {
      setCartError(e)
    }
  }, [])

// effect listener localStorage
  useEffect(() => {
    const storageListener = (e) => {
      if (e.key === 'tokenTicket' && e.newValue === null) {
        console.log('storageListener - tokenTicket: ', e)
        setCart(null)
      }
    }
    window.addEventListener('storage', storageListener)
    return () => {
      window.removeEventListener('storage', storageListener)
    }
  }, [])
  
  const changeCart = (cart: Cart) => {
    setCart(cart)
  }
  
  const changeDataBooking = (dataBooking) => {
    setDataBooking(dataBooking)
  }
  
  return {
    cart,
    dataBooking,
    clientName,
    cartError,
    changeCart,
    changeDataBooking
  }
}
